export default "__VITE_ASSET__b54bebb9__"